import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import parse from 'html-react-parser'
import { makeStyles } from '@material-ui/core'

const FAQ = ({ data }) => {
  const classes = useStyles()

  return (
    <div>
      {data?.length !== 0 &&
        data?.map((item) => {
          return (
            <Accordion key={item.question}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls='panel1a-content'
                id='panel1a-header'
                className={classes.accordionSummaryDetails}
              >
                <Typography>{item?.question}</Typography>
              </AccordionSummary>
              <AccordionDetails className={classes.accordinDetails}>
                <Typography>{parse(item?.answer)}</Typography>
              </AccordionDetails>
            </Accordion>
          )
        })}
    </div>
  )
}

export default FAQ

const useStyles = makeStyles({
  accordionSummaryDetails: {
    display: 'flex',
    paddingLeft: '20px',
    paddingRight: '20px',
    fontSize: '14px',
    textAlign: 'left',
  },
  accordinDetails: {
    textAlign: 'initial',
  },
})
